var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.style['alert-container'],
    _vm.dismissible ? _vm.style['alert-dismissible'] : '',
    _vm.hideAlert ? _vm.style['alert-hidden'] : ''
  ],attrs:{"role":"alert"}},[(_vm.dismissible)?_c('button',{staticClass:"close",class:[_vm.style['alert-close']],attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){_vm.hideAlert = true}}},[_vm._v("\n    ×\n  ")]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.alerts)+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }